import React, { useState, useEffect } from "react";
import { Bell, Monitor, CircleDot, ChevronDown, User, X, LogOut, Menu } from "lucide-react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { auth, db } from "../../firebase";
import { ref, onValue } from "firebase/database";
import { signOut } from "firebase/auth";
import Userfooter from "./Userfooter";

export default function SubheDashboard() {
    const navigate = useNavigate();
    const location = useLocation();
    const [openIndex, setOpenIndex] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isRegistrationAccepted, setIsRegistrationAccepted] = useState(false);
    const [isFeeAccepted, setIsFeeAccepted] = useState(false);

    const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};

    useEffect(() => {
        if (currentUser._key && currentUser._node) {
            const regRef = ref(db, `${currentUser._node}/${currentUser._key}/payments/Registration invoice/accountantStatus`);
            const feeRef = ref(db, `${currentUser._node}/${currentUser._key}/payments/Registration status invoice/accountantStatus`);

            const unsubReg = onValue(regRef, (snapshot) => {
                setIsRegistrationAccepted(snapshot.exists() && snapshot.val() === 'accepted');
            });

            const unsubFee = onValue(feeRef, (snapshot) => {
                setIsFeeAccepted(snapshot.exists() && snapshot.val() === 'accepted');
            });

            return () => {
                unsubReg();
                unsubFee();
            };
        }
    }, [currentUser._key, currentUser._node]);

    const allMenuItems = [
        { name: "डॅशबोर्ड", path: "/subhe-dashboard", icon: <Monitor size={18} /> },
        { name: "अर्जदाराची संपूर्ण माहिती", path: "/subhe-dashboard/applicant-information", icon: <Monitor size={18} /> },
        { name: "डॉक्युमेंट डिटेल्स", path: "/subhe-dashboard/documents", icon: <CircleDot size={18} /> },
        {
            name: "रजिस्ट्रेशन चलन",
            icon: <CircleDot size={18} />,
            children: [
                { name: "डाउनलोड नोंदणी चलन", path: "/subhe-dashboard/challan-download" },
                { name: "डाउनलोड फी चलन", path: "/subhe-dashboard/challan-status" },
                { name: "अपलोड चलन", path: "/subhe-dashboard/challan-upload" },
            ],
        },
        {
            name: "इंटरेस्टेड वर्क लिस्ट",
            icon: <Monitor size={18} />,
            children: [
                { name: "इंटरेस्टेड वर्क लिस्ट", path: "/subhe-dashboard/worklist" },
                { name: "चलन डाउनलोड करा", path: "/subhe-dashboard/work-selection-challan" },
            ],
        },
        {
            name: "अपलोड प्लॅन करारपत्रक",
            icon: <Monitor size={18} />,
            children: [{ name: "करारपत्रक अपलोड करा", path: "/subhe-dashboard/upload-plant" }],
        },
        { name: "पासबुक अपडेट", path: "/subhe-dashboard/passbook-update", icon: <Monitor size={18} /> },
        { name: "स्टेटस डिटेल्स", path: "/subhe-dashboard/status-details", icon: <Monitor size={18} /> },
        {
            name: "मदत",
            icon: <Monitor size={18} />,
            children: [
                { name: "क्वेरी अपलोड करा", path: "/subhe-dashboard/query-upload" },
                { name: "क्वेरी यादी", path: "/subhe-dashboard/query-list" },
            ],
        },
    ];

    const menuItems = allMenuItems.filter(item => {
        if (item.name === "रजिस्ट्रेशन चलन" && isRegistrationAccepted && isFeeAccepted) {
            return false;
        }
        return true;
    });

    const handleMenuClick = (item) => {
        if (item.path === "/subhe-dashboard/passbook-update") {
            setShowModal(true);
        } else if (item.path) {
            navigate(item.path);
            setIsMobileMenuOpen(false);
        }
    };

    const handleLogout = async () => {
        try {
            await signOut(auth);
            localStorage.removeItem('currentUser');
            navigate('/');
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };

    const userName = currentUser.firstName
        ? `${currentUser.firstName} ${currentUser.surname}`
        : (currentUser.societyName || currentUser.chairmanName || currentUser.name || "वापरकर्ता");

    return (
        <div className="min-h-screen bg-slate-50 font-sans">
            {/* Header */}
            <div className="bg-white px-4 sm:px-6 py-3 flex justify-between items-center border-b border-gray-200 sticky top-0 z-[1001] shadow-sm">
                <div className="flex items-center gap-3">
                    <button 
                        className="xl:hidden text-gray-600 hover:text-gray-900 transition-colors" 
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        {isMobileMenuOpen ? <X size={26} /> : <Menu size={26} />}
                    </button>
                    <h1 className="text-sm sm:text-xl font-extrabold text-gray-900 truncate max-w-[200px] sm:max-w-none">
                        Z.P. SANGLI <span className="hidden sm:inline">- (SUBHE DASHBOARD)</span>
                    </h1>
                </div>

                <div className="flex items-center gap-4 sm:gap-6">
                    <Bell size={22} className="text-slate-500 hover:text-slate-700 cursor-pointer transition-colors" />
                    
                    <div className="relative flex items-center gap-3 cursor-pointer group" onClick={() => setShowProfileMenu(!showProfileMenu)}>
                        <div className="text-right hidden sm:block">
                            <div className="text-sm font-bold text-slate-800">{userName}</div>
                            <div className="text-xs text-slate-500 font-medium uppercase tracking-wider mt-0.5">
                                {currentUser.role ? (currentUser.role.charAt(0).toUpperCase() + currentUser.role.slice(1)) : "अर्जदार"}
                            </div>
                        </div>
                        <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-slate-100 flex items-center justify-center border border-slate-200 group-hover:bg-slate-200 transition-colors">
                            <User size={20} className="text-slate-500" />
                        </div>

                        {/* Profile Dropdown */}
                        {showProfileMenu && (
                            <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-xl shadow-xl border border-slate-200 overflow-hidden z-[1002] animate-in fade-in slide-in-from-top-2">
                                <button
                                    onClick={handleLogout}
                                    className="w-full px-4 py-3 flex items-center gap-3 text-red-600 hover:bg-red-50 text-sm font-bold transition-colors"
                                >
                                    <LogOut size={16} />
                                    लॉगआउट (Logout)
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Desktop Menu */}
            <div className="hidden xl:flex bg-[#22165f] px-4 shadow-md whitespace-nowrap sticky top-[60px] sm:top-[68px] z-[1000]">
                {menuItems.map((item, index) => (
                    <div
                        key={index}
                        className="relative group"
                        onMouseEnter={() => setOpenIndex(index)}
                        onMouseLeave={() => setOpenIndex(null)}
                    >
                        <div
                            onClick={() => {
                                handleMenuClick(item);
                                if (item.children) setOpenIndex(openIndex === index ? null : index);
                            }}
                            className={`px-4 py-3.5 text-white cursor-pointer flex items-center gap-2 text-[13px] font-semibold transition-all duration-200
                                ${(location.pathname === item.path || (item.children && item.children.some(child => location.pathname === child.path)) || openIndex === index)
                                    ? "bg-[#0096e1]" : "hover:bg-[#30227a]"}`}
                        >
                            <span className="opacity-80">{item.icon}</span>
                            {item.name}
                            {item.children && <ChevronDown size={14} className="opacity-70" />}
                        </div>

                        {/* Desktop Dropdown */}
                        {item.children && openIndex === index && (
                            <div className="absolute top-full left-0 bg-white min-w-[240px] shadow-xl border border-slate-200 rounded-b-lg overflow-hidden z-[1000]">
                                {item.children.map((sub, i) => (
                                    <div
                                        key={i}
                                        onClick={() => navigate(sub.path)}
                                        className={`px-5 py-3 text-sm cursor-pointer border-b border-slate-100 last:border-0 transition-colors
                                            ${location.pathname === sub.path ? "bg-blue-50 text-blue-600 font-bold" : "text-slate-600 hover:bg-slate-50 hover:text-blue-600"}`}
                                    >
                                        {sub.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="xl:hidden bg-[#22165f] absolute w-full z-[1000] shadow-xl max-h-[calc(100vh-60px)] overflow-y-auto animate-in slide-in-from-top-2">
                    {menuItems.map((item, index) => (
                        <div key={index} className="border-b border-white/10">
                            <div 
                                onClick={() => { 
                                    handleMenuClick(item); 
                                    if(item.children) setOpenIndex(openIndex === index ? null : index); 
                                }} 
                                className={`px-5 py-4 text-white flex justify-between items-center transition-colors ${openIndex === index ? 'bg-[#30227a]' : 'hover:bg-white/5'}`}
                            >
                                <div className="flex items-center gap-3">
                                    <span className="opacity-80">{item.icon}</span> 
                                    <span className="text-sm font-semibold">{item.name}</span>
                                </div>
                                {item.children && (
                                    <ChevronDown size={18} className={`opacity-70 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} />
                                )}
                            </div>
                            
                            {item.children && openIndex === index && (
                                <div className="bg-[#1a1048] py-1 border-t border-white/5">
                                    {item.children.map((sub, i) => (
                                        <div 
                                            key={i} 
                                            onClick={() => { 
                                                navigate(sub.path); 
                                                setIsMobileMenuOpen(false); 
                                            }} 
                                            className={`px-12 py-3 text-sm transition-colors border-b border-white/5 last:border-0
                                                ${location.pathname === sub.path ? 'text-blue-400 font-bold' : 'text-slate-300 hover:text-white hover:bg-white/5'}`}
                                        >
                                            {sub.name}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* Passbook Update Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-[2000] backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl overflow-hidden shadow-2xl w-full max-w-md animate-in zoom-in-95 duration-200">
                        <div className="px-6 py-4 bg-slate-50 border-b border-slate-200 flex justify-between items-center">
                            <h2 className="text-lg font-bold text-slate-800">कामवाटपातील कामे (पासबुक)</h2>
                            <button onClick={() => setShowModal(false)} className="text-slate-400 hover:text-slate-600 transition-colors">
                                <X size={22} />
                            </button>
                        </div>
                        <div className="p-6 md:p-8 text-center text-slate-600 text-base leading-relaxed">
                            या पूर्वी कामवाटपामध्ये काम मिळाले आहेत का? असेल तर पासबुक भरून घ्यावे.
                        </div>
                        <div className="px-6 py-4 bg-slate-50 border-t border-slate-200 flex justify-end gap-3">
                            <button
                                onClick={() => { setShowModal(false); navigate("/subhe-dashboard"); }}
                                className="px-5 py-2.5 bg-slate-200 hover:bg-slate-300 text-slate-700 rounded-lg font-bold transition-colors"
                            >
                                नाही
                            </button>
                            <button
                                onClick={() => { setShowModal(false); navigate("/subhe-dashboard/passbook-update"); }}
                                className="px-5 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-bold shadow-md shadow-indigo-200 transition-all active:scale-95"
                            >
                                होय
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Page Content */}
            <div className="p-4 sm:p-6 md:p-8 max-w-[1600px] mx-auto min-h-[calc(100vh-140px)] flex flex-col">
                <div className="flex-1">
                    <Outlet />
                </div>
                <div className="mt-8">
                    <Userfooter />
                </div>
            </div>
        </div>
    );
}
